<template>
    <div v-show="visible">
        <el-dialog title="查看被审核人" 
            element-loading-background = "rgba(255, 255,255,0.7)"
            :element-loading-text = "loadingText"
            v-loading="loading"
            :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="550px">    
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="350"
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name" label="姓名"  :show-overflow-tooltip="true" width="130"></el-table-column>
                <el-table-column prop="deptIdstrName"  label="所属机构" :show-overflow-tooltip="true" ></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                },
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                data:[]
            }
        },
        components: {
        },
        created:function () {
        },
        methods:{
            init(id){
                this.visible=true;
                this.form.id=id;
                this.data=[];
                this.getData();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            getData(){
                this.loading=true;
                this.loadingText="数据在加载中...";

                let url  = this.teacherAssessList2Url;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    teacherTemplateManageId:this.form.id,
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){ 
                       this.data=res.data.list;
                       this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/template/LookTeacherAssess.vue